import React from 'react';
import LoadingSpinner from './LoadingSpinner';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from '../ui/Button';

interface LazyLoadingFallbackProps {
  componentName?: string;
  message?: string;
  error?: boolean;
}

const LazyLoadingFallback: React.FC<LazyLoadingFallbackProps> = ({
  componentName = 'Component',
  message,
  error = false,
}) => {
  if (error) {
    return (
      <div className="flex flex-col items-center justify-center p-4 text-center">
        <AlertTriangle className="w-8 h-8 text-accent-warning mb-3" />
        <h5 className="text-text-muted font-medium mb-2">Failed to load {componentName}</h5>
        <p className="text-text-muted text-sm mb-3">
          The component failed to load. Please refresh the page or try again.
        </p>
        <Button
          variant="outline"
          size="sm"
          onClick={() => window.location.reload()}
        >
          <RefreshCw className="w-4 h-4 mr-2" />
          Refresh Page
        </Button>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center p-4">
      <LoadingSpinner
        size="lg"
        variant="primary"
        text={message || `Loading ${componentName}...`}
        centered={true}
      />
      <div className="mt-3 text-center">
        <small className="text-text-muted">
          Preparing advanced features...
        </small>
      </div>
    </div>
  );
};

export default LazyLoadingFallback;
